<script>
import {questionnaireList,userQuestionnaireResult} from "@/lib/request";
import { getLocalItem} from '@/untils/common';
// 加载中
import InnerLoading from '@/components/spinner/spinner.vue';
export default {
  name: 'activeList',
  data() {
    return {
      innerLoading:false,
      paramsBankId:'',
      paramsId:'',
      objContent: {},
      dataFields:[],
      form:{},
      weightList:[
        {
          weight_min:65,
          weight_max:70,
        },{
          weight_min:70,
          weight_max:75,
        },{
          weight_min:75,
          weight_max:80,
        },{
          weight_min:80,
          weight_max:85,
        },{
          weight_min:85,
          weight_max:90,
        },
      ],
      heightList:[
        {
          height_min:160,
          height_max:165,
        },{
          height_min:165,
          height_max:170,
        },{
          height_min:170,
          height_max:175,
        },{
          height_min:175,
          height_max:180,
        },{
          height_min:180,
          height_max:185,
        },{
          height_min:185,
          height_max:190,
        },
      ],
      sizeAutoList:[
        [
          {
            height_min:160,
            height_max:165,
            weight_min:65,
            weight_max:70,
            size:'M码'
          },{
            height_min:160,
            height_max:165,
            weight_min:70,
            weight_max:75,
            size:'L码'
          },{
            height_min:160,
            height_max:165,
            weight_min:75,
            weight_max:80,
            size:'L码'
          },{
            height_min:160,
            height_max:165,
            weight_min:80,
            weight_max:85,
            size:'XL码'
          },{
            height_min:160,
            height_max:165,
            weight_min:85,
            weight_max:90,
            size:'XXL码'
          },
        ],[
          {
            height_min:165,
            height_max:170,
            weight_min:65,
            weight_max:70,
            size:'M码'
          },{
            height_min:165,
            height_max:170,
            weight_min:70,
            weight_max:75,
            size:'L码'
          },{
            height_min:165,
            height_max:170,
            weight_min:75,
            weight_max:80,
            size:'L码'
          },{
            height_min:165,
            height_max:170,
            weight_min:80,
            weight_max:85,
            size:'XL码'
          },{
            height_min:165,
            height_max:170,
            weight_min:85,
            weight_max:90,
            size:'XXL码'
          },
        ],[
          {
            height_min:170,
            height_max:175,
            weight_min:65,
            weight_max:70,
            size:'L码'
          }, {
            height_min:170,
            height_max:175,
            weight_min:70,
            weight_max:75,
            size:'L码'
          },{
            height_min:170,
            height_max:175,
            weight_min:75,
            weight_max:80,
            size:'XL码'
          },{
            height_min:170,
            height_max:175,
            weight_min:80,
            weight_max:85,
            size:'XL码'
          },{
            height_min:170,
            height_max:175,
            weight_min:85,
            weight_max:90,
            size:'XXL码'
          },
        ],[
         {
            height_min:175,
            height_max:180,
            weight_min:65,
            weight_max:70,
            size:'L码'
          }, {
            height_min:175,
            height_max:180,
            weight_min:70,
            weight_max:75,
            size:'L码'
          },{
            height_min:175,
            height_max:180,
            weight_min:75,
            weight_max:80,
            size:'XL码'
          }, {
            height_min:175,
            height_max:180,
            weight_min:80,
            weight_max:85,
            size:'XXL码'
          },{
            height_min:175,
            height_max:180,
            weight_min:85,
            weight_max:90,
            size:'XXL码'
          },
        ],[
          {
            height_min:180,
            height_max:185,
            weight_min:65,
            weight_max:70,
            size:'L码'
          },{
            height_min:180,
            height_max:185,
            weight_min:70,
            weight_max:75,
            size:'XL码'
          },{
            height_min:180,
            height_max:185,
            weight_min:75,
            weight_max:80,
            size:'XL码'
          },{
            height_min:180,
            height_max:185,
            weight_min:80,
            weight_max:85,
            size:'XXL码'
          },{
            height_min:180,
            height_max:185,
            weight_min:85,
            weight_max:90,
            size:'XXL码'
          },
        ],[
          {
            height_min:185,
            height_max:190,
            weight_min:65,
            weight_max:70,
            size:'XL码'
          },{
            height_min:185,
            height_max:190,
            weight_min:70,
            weight_max:75,
            size:'XL码'
          },{
            height_min:185,
            height_max:190,
            weight_min:75,
            weight_max:80,
            size:'XL码'
          },{
            height_min:185,
            height_max:190,
            weight_min:80,
            weight_max:85,
            size:'XXL码'
          },{
            height_min:185,
            height_max:190,
            weight_min:85,
            weight_max:90,
            size:'XXL码'
          },
        ]
      ],
      sizeAutoList_1:[
        {
          height_min:160,
          height_max:165,
          weight_min:65,
          weight_max:70,
          size:'M码'
        },{
          height_min:160,
          height_max:165,
          weight_min:70,
          weight_max:75,
          size:'L码'
        },{
          height_min:160,
          height_max:165,
          weight_min:75,
          weight_max:80,
          size:'L码'
        },{
          height_min:160,
          height_max:165,
          weight_min:80,
          weight_max:85,
          size:'XL码'
        },{
          height_min:160,
          height_max:165,
          weight_min:85,
          weight_max:90,
          size:'XXL码'
        },
        {
          height_min:165,
          height_max:170,
          weight_min:65,
          weight_max:70,
          size:'M码'
        },{
          height_min:165,
          height_max:170,
          weight_min:70,
          weight_max:75,
          size:'L码'
        },{
          height_min:165,
          height_max:170,
          weight_min:75,
          weight_max:80,
          size:'L码'
        },{
          height_min:165,
          height_max:170,
          weight_min:80,
          weight_max:85,
          size:'XL码'
        },{
          height_min:165,
          height_max:170,
          weight_min:85,
          weight_max:90,
          size:'XXL码'
        },
        {
          height_min:170,
          height_max:175,
          weight_min:65,
          weight_max:70,
          size:'L码'
        }, {
          height_min:170,
          height_max:175,
          weight_min:70,
          weight_max:75,
          size:'L码'
        },{
          height_min:170,
          height_max:175,
          weight_min:75,
          weight_max:80,
          size:'XL码'
        },{
          height_min:170,
          height_max:175,
          weight_min:80,
          weight_max:85,
          size:'XL码'
        },{
          height_min:170,
          height_max:175,
          weight_min:85,
          weight_max:90,
          size:'XXL码'
        },
        {
          height_min:175,
          height_max:180,
          weight_min:65,
          weight_max:70,
          size:'L码'
        }, {
          height_min:175,
          height_max:180,
          weight_min:70,
          weight_max:75,
          size:'L码'
        },{
          height_min:175,
          height_max:180,
          weight_min:75,
          weight_max:80,
          size:'XL码'
        }, {
          height_min:175,
          height_max:180,
          weight_min:80,
          weight_max:85,
          size:'XXL码'
        },{
          height_min:175,
          height_max:180,
          weight_min:85,
          weight_max:90,
          size:'XXL码'
        },
        {
          height_min:180,
          height_max:185,
          weight_min:65,
          weight_max:70,
          size:'L码'
        },{
          height_min:180,
          height_max:185,
          weight_min:70,
          weight_max:75,
          size:'XL码'
        },{
          height_min:180,
          height_max:185,
          weight_min:75,
          weight_max:80,
          size:'XL码'
        },{
          height_min:180,
          height_max:185,
          weight_min:80,
          weight_max:85,
          size:'XXL码'
        },{
          height_min:180,
          height_max:185,
          weight_min:85,
          weight_max:90,
          size:'XXL码'
        },
        {
          height_min:185,
          height_max:190,
          weight_min:65,
          weight_max:70,
          size:'XL码'
        },{
          height_min:185,
          height_max:190,
          weight_min:70,
          weight_max:75,
          size:'XL码'
        },{
          height_min:185,
          height_max:190,
          weight_min:75,
          weight_max:80,
          size:'XL码'
        },{
          height_min:185,
          height_max:190,
          weight_min:80,
          weight_max:85,
          size:'XXL码'
        },{
          height_min:185,
          height_max:190,
          weight_min:85,
          weight_max:90,
          size:'XXL码'
        },
      ],
    }
  },
  components:{
    InnerLoading
  },
  computed: {
    firstItemValue() {
      return this.dataFields[0]?.id ? this.dataFields[0]?.answer : null;
    },
    secondItemValue() {
      return this.dataFields[1]?.id ? this.dataFields[1]?.answer : null;
    },
  },
  watch: {
    firstItemValue(newVal, oldVal) {
      if (!newVal || !oldVal) return;
      if (newVal !== oldVal) {
        let height = Number(newVal);
        let weight = Number(this.secondItemValue);
        //   工服按照身高体重计算选择尺码
        //   ----------2025-07-25提出需求，
        // 身高100-250cm
        if(height>99&&height<251){
          // 体重35-999公斤
          if(weight) {
            if(weight>34&&weight<1000){
              this.sizeAutoList_1.map((v) => {
                if (height >= v.height_min && height <= v.height_max) {
                  if (weight >= v.weight_min && weight <= v.weight_max) {
                    this.dataFields[2].options.map((i) => {
                      if (v.size === i.content) {
                        this.dataFields[2].answer = i.id;
                      }
                    });
                    this.dataFields[3].options.map((i) => {
                      if (v.size === i.content) {
                        this.dataFields[3].answer = i.id;
                      }
                    });
                  }else{
                    if(weight<65){
                      this.dataFields[2].answer = this.dataFields[2].options[0].id;
                      this.dataFields[3].answer = this.dataFields[3].options[0].id;
                    }
                    if(weight>90){
                      this.dataFields[2].answer = this.dataFields[2].options[this.dataFields[2].options.length-1].id;
                      this.dataFields[3].answer = this.dataFields[3].options[this.dataFields[3].options.length-1].id;
                    }
                  }
                }else{
                  if(height<160){
                    if(weight<65){
                      this.dataFields[2].answer = this.dataFields[2].options[0].id;
                      this.dataFields[3].answer = this.dataFields[3].options[0].id;
                    }else if(weight>90){
                      this.dataFields[2].answer = this.dataFields[2].options[this.dataFields[2].options.length-1].id;
                      this.dataFields[3].answer = this.dataFields[3].options[this.dataFields[3].options.length-1].id;
                    }else{
                      // this.dataFields[2].answer = this.dataFields[2].options[0].id;
                      // this.dataFields[3].answer = this.dataFields[3].options[0].id;
                      this.sizeAutoList[0].map((v) => {
                        // if (height >= v.height_min && height <= v.height_max) {
                        if (weight >= v.weight_min && weight <= v.weight_max) {
                          this.dataFields[2].options.map((i) => {
                            if (v.size === i.content) {
                              this.dataFields[2].answer = i.id;
                            }
                          });
                          this.dataFields[3].options.map((i) => {
                            if (v.size === i.content) {
                              this.dataFields[3].answer = i.id;
                            }
                          });
                        }
                        // }
                      });
                    }
                  }else if(height>190){
                    if(weight<65){
                      this.dataFields[2].answer = this.dataFields[2].options[0].id;
                      this.dataFields[3].answer = this.dataFields[3].options[0].id;
                    }else if(weight>90){
                      this.dataFields[2].answer = this.dataFields[2].options[this.dataFields[2].options.length-1].id;
                      this.dataFields[3].answer = this.dataFields[3].options[this.dataFields[3].options.length-1].id;
                    }else{
                      // this.dataFields[2].answer = this.dataFields[2].options[this.dataFields[2].options.length-1].id;
                      // this.dataFields[3].answer = this.dataFields[3].options[this.dataFields[3].options.length-1].id;
                      this.sizeAutoList[this.sizeAutoList.length-1].map((v) => {
                        // if (height >= v.height_min && height <= v.height_max) {
                        if (weight >= v.weight_min && weight <= v.weight_max) {
                          this.dataFields[2].options.map((i) => {
                            if (v.size === i.content) {
                              this.dataFields[2].answer = i.id;
                            }
                          });
                          this.dataFields[3].options.map((i) => {
                            if (v.size === i.content) {
                              this.dataFields[3].answer = i.id;
                            }
                          });
                        }
                        // }
                      });
                    }
                  }
                }
              });
            }
          }
        }
      }
    },
    secondItemValue(newVal, oldVal) {
      if (!newVal || !oldVal) return;
      if (newVal !== oldVal) {
        let height = Number(this.firstItemValue);
        let weight = Number(newVal);
        //   工服按照身高体重计算选择尺码
        //   ----------2025-07-25提出需求，
        // 身高100-250cm
        if(height>99&&height<251){
          // 体重35-999公斤
          if(weight>34&&weight<1000) {
            this.sizeAutoList_1.map((v) => {
              if (height >= v.height_min && height <= v.height_max) {
                if (weight >= v.weight_min && weight <= v.weight_max) {
                  this.dataFields[2].options.map((i) => {
                    if (v.size === i.content) {
                      this.dataFields[2].answer = i.id;
                    }
                  });
                  this.dataFields[3].options.map((i) => {
                    if (v.size === i.content) {
                      this.dataFields[3].answer = i.id;
                    }
                  });
                }else{
                  if(weight<65){
                    this.dataFields[2].answer = this.dataFields[2].options[0].id;
                    this.dataFields[3].answer = this.dataFields[3].options[0].id;
                  }
                  if(weight>90){
                    this.dataFields[2].answer = this.dataFields[2].options[this.dataFields[2].options.length-1].id;
                    this.dataFields[3].answer = this.dataFields[3].options[this.dataFields[3].options.length-1].id;
                  }
                }
              }else{
                if(height<160){
                  if(weight<65){
                    this.dataFields[2].answer = this.dataFields[2].options[0].id;
                    this.dataFields[3].answer = this.dataFields[3].options[0].id;
                  }else if(weight>90){
                    this.dataFields[2].answer = this.dataFields[2].options[this.dataFields[2].options.length-1].id;
                    this.dataFields[3].answer = this.dataFields[3].options[this.dataFields[3].options.length-1].id;
                  }else{
                    this.sizeAutoList[0].map((v) => {
                        if (weight >= v.weight_min && weight <= v.weight_max) {
                          this.dataFields[2].options.map((i) => {
                            if (v.size === i.content) {
                              this.dataFields[2].answer = i.id;
                            }
                          });
                          this.dataFields[3].options.map((i) => {
                            if (v.size === i.content) {
                              this.dataFields[3].answer = i.id;
                            }
                          });
                        }
                    });
                  }
                }else if(height>190){
                  if(weight<65){
                    this.dataFields[2].answer = this.dataFields[2].options[0].id;
                    this.dataFields[3].answer = this.dataFields[3].options[0].id;
                  }else if(weight>90){
                    this.dataFields[2].answer = this.dataFields[2].options[this.dataFields[2].options.length-1].id;
                    this.dataFields[3].answer = this.dataFields[3].options[this.dataFields[3].options.length-1].id;
                  }else{
                    this.sizeAutoList[this.sizeAutoList.length-1].map((v) => {
                      if (weight >= v.weight_min && weight <= v.weight_max) {
                        this.dataFields[2].options.map((i) => {
                          if (v.size === i.content) {
                            this.dataFields[2].answer = i.id;
                          }
                        });
                        this.dataFields[3].options.map((i) => {
                          if (v.size === i.content) {
                            this.dataFields[3].answer = i.id;
                          }
                        });
                      }
                    });
                  }
                }
              }
            });
          }else{
            this.$toast('请您检查您输入的体重，是否正确');
          }
        }else{
          this.$toast('请您检查您输入的身高，是否正确');
        }
      }
    },
  },
  created() {
    if(this.$route.query.id&&this.$route.query.sid){
      this.paramsId = this.$route.query.id;
      this.paramsBankId = this.$route.query.sid;
      this.getDataInfo();
    }
  },
  methods: {
    onSubmit() {
      const emptyField = this.dataFields.find(item => !item.answer);
      if (emptyField) {
        this.$toast(`请完善 ${emptyField.content} 信息！`);
        return false;
      }
      let arr = [];
      this.dataFields.map((v)=>{
        if(Array.isArray(v.answer)){
          v.nameValue = v.answer.join(',');
        }else{
          v.nameValue = v.answer+'';
        }
        arr.push({questionId:v.id,answer:v.nameValue});
      });

      if(getLocalItem('user_id')){
        if(getLocalItem('nickName')){
          this.innerLoading = true;
          this.form.userId = getLocalItem('user_id');//userId
          this.form.userName = getLocalItem('nickName');//用户姓名
          this.form.roleName = getLocalItem('local_role');//角色
          this.form.branchId = this.paramsBankId;//网点编号
          this.form.questionnaireId = this.objContent.id;
          this.form.answers = arr;
          userQuestionnaireResult(this.form).then((res) => {
            if (res) {
              if (res.data) {
                this.innerLoading = false;
                if (res.data.code === 200) {
                  // this.getDataInfo();
                  this.objContent.allowEdit = false;
                  this.$toast.success(res.data.msg);
                  setTimeout(()=>{
                    this.$router.go(-1);
                  },1000);
                } else {
                  this.$toast.fail(res.data.msg)
                }
              }
            }
          });
        }else{
          this.$toast('抱歉没有您的nickName，请您退出重新登录！');
        }
      }else{
        this.$toast('抱歉没有您的userId，请您退出重新登录！');
      }
    },
    getDataInfo() {
      if(this.paramsId&&getLocalItem('user_id')) {
        questionnaireList({
          id: this.paramsId,
          userId:getLocalItem('user_id')
        }).then((res) => {
          if (res) {
            if (res.data) {
              if (res.data.code === 200) {
                if (res.data.data.questions && res.data.data.questions.length > 0) {
                  this.objContent = res.data.data;
                  res.data.data.questions.map((v, k) => {
                    v.key = k + 1;
                  });
                  this.dataFields = res.data.data.questions;
                }
              } else {
                if (res.data.msg) {
                  this.$toast.fail(res.data.msg);
                }
              }
              this.innerLoading = false;
            }
          }
        });
      }
    }
  }
}
</script>
<template>
  <div>
    <inner-loading v-model="innerLoading"></inner-loading>
      <div class="form-inner">
        <div class="card">
          <div class="section-title">{{ objContent.title }}</div>
          <p class="section-text">{{objContent.description}}</p>
          <div class="form-item" v-for="(item,index) in dataFields" :key="index">
            <div class="form-label">{{index+1}}、{{ item.content }} <span style="color: red">*</span></div>
            <!--      1      单选-->
            <div v-if="item.type===1">
              <van-radio-group v-model="item.answer" direction="horizontal" :disabled="!objContent.allowEdit">
                <van-radio :name="val.id" v-for="(val,k) in item.options" :key="k" >{{val.content}}</van-radio>
              </van-radio-group>
              <div v-if="item.imageURL"><img style="width: 100%" :src="item.imageURL" alt=""></div>
            </div>
            <!--     2       复选-->
            <div v-else-if="item.type===2">
              <van-checkbox-group v-model="item.answer" direction="horizontal" :disabled="!objContent.allowEdit">
                <van-checkbox :name="val.id" v-for="(val,k) in item.options" :key="k" shape="square">{{val.content}}</van-checkbox>
              </van-checkbox-group>
              <div v-if="item.imageURL"><img style="width: 100%" :src="item.imageURL" alt=""></div>
            </div>
            <!--       3     文本框-->
            <div v-else-if="item.type===3">
              <van-field
                  v-model="item.answer"
                  name="name"
                  label=""
                  type="number"
                  autocomplete="off"
                  :readonly="!objContent.allowEdit"
                  :placeholder="`${item.content}`"
              />
              <div v-if="item.imageURL"><img style="width: 100%" :src="item.imageURL" alt=""></div>
            </div>
            <!--   长文本  -->
            <div v-else-if="item.type===5">
              <van-field
                  v-model="item.answer"
                  name="name"
                  label=""
                  autocomplete="off"
                  :readonly="!objContent.allowEdit"
                  type="textarea"
                  :placeholder="`${item.name}`"
              />
              <div v-if="item.imageURL"><img style="width: 100%" :src="item.imageURL" alt=""></div>
            </div>
          </div>
        </div>
        <div class="form-buttons">
          <van-button round block class="btn btn-primary" :disabled="!objContent.allowEdit" @click="onSubmit">{{!objContent.allowEdit?'已提交':'提交'}}</van-button>
        </div>
<!--        <div class="flex-clouds">-->
<!--          <div class="flex-clo">-->
<!--            <div class="flex-rows-item">-->
<!--              <table border="1">-->
<!--                <tr>-->
<!--                  <td>身高/体重</td>-->
<!--                </tr>-->
<!--              </table>-->
<!--            </div>-->
<!--            <div class="flex-rows-item">-->
<!--              <table border="1">-->
<!--                <tr>-->
<!--                  <td  v-for="(v,k) in weightList" :key="k">{{v.weight_min}}-{{v.weight_max}}</td>-->
<!--                </tr>-->
<!--              </table>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="flex-clo">-->
<!--            <div class="flex-rows-item">-->
<!--              <table border="1">-->
<!--                <tr v-for="(v,k) in heightList" :key="k">-->
<!--                  <td>{{v.height_min}} - {{v.height_max}}</td>-->
<!--                </tr>-->
<!--              </table>-->
<!--            </div>-->
<!--            <div class="flex-rows-item">-->
<!--              <table border="1">-->
<!--                <tr v-for="(v,k) in sizeAutoList" :key="k">-->
<!--                  <td v-for="(i,key) in v" :key="key">{{i.size}}</td>-->
<!--                </tr>-->
<!--              </table>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
      </div>
  </div>
</template>
<style lang="scss" scoped>
.form-inner{
  padding:20px 20px 20px 20px;
  width: 100%;
  .flex-clouds{
    display: flex;
    flex-direction: column;
    width: 100%;
    .flex-clo{
      display: flex;
      flex-direction: row;
      .flex-rows-item{
        display: flex;
      }
    }
  }
  .card{
    padding: 20px;

    .section-title {
      font-size: 33px;
      text-align: center;
      padding-top: 10px;
      padding-bottom: 20px;
      justify-content: center;
      font-weight: bold;
    }
    .section-text{
      color: #666;
      padding-bottom: 20px;
    }
    .form-item {
      margin-bottom:30px;

      .van-cell{
        background: #f9f9f9;
      }
      .form-label {
        display: block;
        margin-bottom: 20px;
        color: #222;
        font-size: 33px;
      }

      .form-input {
        width: 100%;
        padding:20px 20px;
        border: 1px solid #ddd;
        border-radius: 15px;
        background: white;
      }
    }
  }
}
</style>
